exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  background: #f5f5f5;\n}\nbody #error-page {\n  background: url(" + require("../images/404-error.png") + ") no-repeat 100% 0;\n  min-height: 400px;\n  max-width: 650px;\n  padding: 19px 29px 29px;\n  margin: 100px auto 20px;\n}\nbody #error-page >div {\n  float: right;\n  margin-right: 320px;\n  text-align: right;\n}\nbody #error-page h1.error-code {\n  font-family: Impact;\n  font-size: 180px;\n  line-height: 180px;\n  color: ;\n  text-shadow: 0 1px #944040;\n}\nbody #error-page p.error-message {\n  font-size: 24px;\n  line-height: 24px;\n  text-transform: uppercase;\n  color: #999;\n  text-shadow: 0 1px #fff;\n  margin-right: 10px;\n}\nbody #error-page a {\n  text-decoration: none;\n  color: ;\n}\nbody #error-page a:hover {\n  text-decoration: none;\n  color: #000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/assets/css/error.css
// module id = 376
// module chunks = 1